module.exports = {
  buttons: {
    backLink: "返回",
    cancelButton: "取消",
    chatWithAgentButton: "与代理联系",
    closeButton: "关闭",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">联系技术支持</a>',
    copiedButton: "已复制",
    copyButton: "复制",
    getStartedButton: "快速入门",
    haveAQuestion: "有疑问？",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/contact-support/installation-activation/activation-registration">有疑问？</a>',
    nextButton: "下一步",
    requiredLabel: "必填",
    restartButton: "重新启动",
    signInButton: "登录",
    submitAgainButton: "重新提交",
    submitButton: "提交",
    tryAgainButton: "请重试",
    notNow: "稍后",
    validate: "验证"
  },
  signIn: {
    gatheringInfo: "正在收集您的帐户信息",
    helloUser: "尊敬的 <first-name>：",
    justAMoment: "请稍候...",
    signInNow: "<a>立即登录</a>",
    signInHelp: `<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/contact-support/account-management/account-creation-sign-profile-management">登录时遇到问题？</a>`,
    startAccessAccount: "首先访问您的帐户。"
  },
  contactOptions: {
    addtlComments: "其他备注（可选）",
    addtlCommentsMsg: "我们将使用上述详细信息为您创建案例。使用此空间可添加我们应了解的任何其他内容。",
    addtlCommentsReqd: "说明",
    agentAvailable: "代理可用",
    agentAvailableStdby: "代理可用 - 待命",
    agentUnavailable: "代理不可用",
    cancelCase: "取消案例",
    cancelChat: "取消聊天",
    caseConfirm1: "您很快会收到一封确认电子邮件。如果您没有收到电子邮件，请检查您的垃圾邮件文件夹。",
    caseConfirm2: "代理将审查您的案例，并在 2 个工作日内回复您。",
    caseDetails: "案例详细信息",
    caseNumber: "案例编号：<case-number>",
    caseSubmitted: "案例已提交",
    chatWithAgent: "与代理联系",
    closingWindowMsg: "如果在取得联系之前关闭此窗口，则可能会取消聊天",
    connectMomentarily: "将立即与您联系。",
    createCase: "创建案例",
    errorLabel: "错误",
    forceStartChat: "<a>单击此处开始聊天。</a>",
    getCaseAnswer2Days: "在两天内获得答案",
    mayCloseWindow: "您现在可以关闭此窗口。",
    note: "注意：",
    orSubmitCase: "或<a>提交案例<a/>，相关人员将在 2 个工作日内回复您。",
    popUpBlocker: "存在弹出窗口阻止程序？",
    productLabel: "产品",
    sorryNoAgent: "很抱歉，代理不可用",
    willUpdateAgent: "一旦代理可用，我们将立即更新此屏幕。",
    yourContactInfo: "您的联系信息"
  },
  welcome: {
    important: "重要信息：",
    noteForTheUser: "注意："
  },
  captchaScreen: {
    correctMsg: "正确！",
    incorrectMsg: "错误。请重试。",
    pageTitle: "安全检查",
    typeCaptchaLabel: "输入上面显示的字符"
  },
  contactInfoScreen: {
    emailDisclaimer: "我们需要此信息以便向您发送确认电子邮件。",
    emailTitle: "电子邮件",
    firstNamePlaceholder: "名字",
    lastNamePlaceholder: "姓氏",
    nameLabel: "姓名",
    pageTitle: "1. 您的联系信息"
  },
  reviewAccountInfo: {
    differentAccount: "<a>登录其他帐户</a>",
    emailConfirm: "我们将使用此电子邮件激活您的帐户并向您发送确认。",
    helloUser: "尊敬的 <first-name>：",
    pageTitle: "1. 查看您的帐户信息",
    signedInAs: "您的登录身份为："
  },
  processInfoScreen: {
    checkSerialMsg: "要检查此序列号，请按 Enter 键。",
    continueTyping: "继续键入序列号，格式为：XXX-XXXXXXXX。",
    doNotNeedHula: "<strong>好消息！</strong>您无需申请单独的居家使用许可。您可以使用同一序列号在家用计算机上安装并激活软件。",
    downloadYourProduct: `下载并安装产品。不需要进行额外激活。`,
    emailForSerialNumPlaceholder: "关联的电子邮件",
    emailForSerialNumTitle: "与序列号关联的电子邮件",
    emailForSerialNumTooltip: "该电子邮件地址为软件协调员、合约经理或购买本软件的用户的电子邮件地址",
    ineligiblePerpetual: '该序列号适用于<b>不符合</b>居家使用条件的永久使用许可。<br/><br/>许可条件下，可以随时随地使用我们软件的固定期限的使用许可。<a target="_blank" href="https://www.autodesk.com.cn/subscription">了解有关固定期限的使用许可权益的更多信息</a>。',
    justTypeIn: "- 如果未列出您的序列号，只需键入即可。-",
    msgEducationSerialNum: "这是教育序列号。",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.com.cn/education/free-software/all">转到 Education Community</a>',
    msgIndustryCollectionSerialNum: "该序列号是以下软件集的一部分：<collection-name>",
    msgNetworkSerialNum: `该序列号适用于<Strong>网络许可</Strong>，不需要激活码。请联系网络管理员以确保您的许可已正确设置。`,
    msgSubscriptionSoftware: `该序列号适用于<Strong>固定期限的使用许可软件</Strong>，不需要激活码。请在连接到 Internet 的情况下启动产品。然后，只需<a target="_blank" href="https://www.autodesk.com/sign-in-activation-chs">登录</a>或<a target="_blank" href="https://www.autodesk.com/access-with-serial-number-chs">输入序列号</a>。`,
    msgBiCIndirectSoftware: "我们改进了帐户体验，因此您的许可不再需要激活码。只需使用您的 Autodesk 电子邮件和密码，即可登录并开始使用软件（请确保您已连接 Internet）。",
    msgBicIndirectSCRole: '“您的许可中不包含软件协调员角色。有关详细信息，请参见<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/account-management/users-software/classic-user-management/hybrid-admin-roles">用户管理的管理员角色</a>。”',
    msgBicIndirectCMRole: '更改合约经理_不_会更改主管理员。您可以在 Autodesk Account 中指定该角色（请参见+<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/account-management/users-software/user-management/primary-admins">主管理员</a>+)。',
    msgSN2010orOlder: `您输入的序列号对应于不再受支持的先前版本。 <a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">查看资格要求</a>`,
    myProductNotListed: "未列出我的产品",
    noResultsMsg: "未找到任何相关结果。输入序列号，格式为：XXX-XXXXXXXX。",
    pageTitle: "2. 产品信息",
    partOfCollection: "您的产品包含在此软件集中：<collection-name>",
    requestCodeTitle: "请求代码",
    requestCodetooltip: '如何查找您的<a target="_blank" href="https://www.autodesk.com/find-request-code-chs">请求代码</a>',
    selectPlaceholder: "选择",
    selectProduct: "选择特定产品",
    selectProductPlaceholder: "选择产品",
    selectYourProductTitle: "选择您的产品：",
    serialNumberLabel: "序列号",
    serialNumberPlaceholder: "按名称搜索或键入一个数字",
    serialNumbersInAccount: "您帐户中的序列号",
    serialNumberTooltip: '如何查找您的<a target="_blank" href="https://www.autodesk.com/find-serial-number-chs">序列号</a>',
    yesOption: `是`,
    noOption: `否`,
    currentInfoTitle: "当前信息",
    contractNumDisclaimer: `如果您的合同编号中含有 1，则包含连字符(-)。`,
    contractNumLabel: "合约编号",
    contractNumTooltip: '在<a target="_blank" href="https://manage.autodesk.com">帐户</a>的“计费和订单”区域中，查找合约编号。'
  },
  authorizationRequestScreen: {
    enterEmail: "输入电子邮件",
    option1: "我确认我是此产品的管理员、合约经理或软件协调员。",
    option2: "我确认我是代表管理员、合约经理或软件协调员提出的申请，他们的电子邮件为：",
    pageTitle: "3. 对此申请的授权",
    selectOne: "请选择一项"
  },
  processingScreen: {
    firstMsg: "正在处理您的请求",
    takingLongerExpected: "所需时间超出预期 - 很抱歉让您等待。",
    updatedMsgLonger: "仍在对其进行处理",
    willTakeSecs: "这可能需要花费几秒钟..."
  },
  successScreen: {
    expirationLine: "<br/>到期日期：<expiration-date>",
    infoWillBeEmailed: "此信息还将通过电子邮件发送给您：<email>",
    pageTitle: "成功",
    prodSeatMulti: "<product-name>（<number-seats> 个座席）<br/>",
    prodSeatSingle: "<product-name>（1 个座席）<br/>",
    pvApprovedMsg: "您的先前版本申请已获批准。",
    pvInstruction: "使用以下信息安装并激活您的软件。",
    reponseText: "您的激活码为：<activation-code>",
    responseText1: "您的居家使用许可申请已获批准。",
    responseText2: "使用以下信息安装并激活您的软件。在安装过程中选择“单机版”。",
    responseText3: "序列号：<serial-number><br/>产品密钥：<product-key>",
    updateDisclaimer: `请等待数小时让更改显示在您的帐户中。`
  },
  errors: {
    emailNotAssocWithSerialNumber: "该电子邮件未与此序列号关联。",
    enterCMSCEmail: "请输入该产品的合约经理或软件协调员的电子邮件",
    enterComments: "输入说明",
    enterEmail: "请输入您的电子邮件地址",
    enterEmailAssociated: "请输入关联电子邮件地址",
    enterFirstName: "请输入您的名字",
    enterLastName: "请输入您的姓氏",
    enterRequestCode: "请输入您的请求代码",
    enterSerialNumber: "请输入您的序列号",
    enterValidFormat: "请输入有效的格式",
    invalidAutodeskSerialNumber: '<p>该 Autodesk 序列号无效。</p><p>请确保您所使用的软件购自官方授权渠道：</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">Autodesk Store</a></li><li><a target="_blank" href="https://www.autodesk.com.cn/resellers/locate-a-reseller">授权经销商</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">教育合作伙伴</a></li></ul>',
    invalidLicenseModel: "该产品的许可模式无效。",
    invalidRequestcode: "请求代码无效",
    invalidSerialNumber: "序列号无效",
    notCMSC: "我们的记录表明，您不是该产品的合约经理或软件协调员。",
    oops: '很抱歉，处理您的请求时出现错误。 <a target="_blank" href="https://knowledge.autodesk.com/zh-hans/contact-support/installation-activation/activation-registration">联系技术支持</a>',
    overActivation: "过度激活",
    productExpired: "您当前尝试激活的产品已过期。",
    reasonForActivation: "激活的原因",
    serialNumNotAssocWithSingleLicense: "该序列号未与单（人）用户许可关联。",
    serialNumNotFound: "未找到序列号",
    serialNumNotRegisteered: '该序列号尚未注册。请先对其进行<a target="_blank" href="http://registeronce.autodesk.com/">注册</a>。'
  },
  requestFailedScreen: {
    caseError: "很抱歉，提交您的案例时出现错误。",
    contactOptionsBelow: `如果您需要帮助，请使用以下选项<a id="go-to-contact-us" href="javascript:void(0);">联系我们</a>。`,
    expiredSubsTitle: `固定期限的使用许可已过期`,
    expiredSubscription: `无法完成您的申请，因为您的固定期限的使用许可已过期。请联系您的帐户管理员或查看您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>以了解续展选项。`,
    inactiveSubsTitle: "固定期限的使用许可无效",
    noActiveSubs: `无法完成您的申请，因为您的固定期限的使用许可尚未激活或已过期。请联系您的帐户管理员或查看您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>以了解续展选项。`,
    pageTitle2: "请求无法完成",
    pageTitle: "请求失败",
    prodNotEligibleTitle: "产品不符合条件",
    prodNotRegisteredTitle: `产品未注册`,
    prodNotRegistered: `无法完成您的申请，因为您的产品尚未注册。<br><br><a target="_blank" href="https://registeronce.autodesk.com">注册产品</a>`,
    responseText: "很抱歉，处理您的请求时出现错误。"
  },
  gac: {
    welcome: {
      clickGetStarted: `单击&ldquo;快速入门&rdquo;以获取激活码。`,
      modalTitle: "获取激活码",
      noteBullet1: `仅当您使用的是单机版永久使用许可或单机版教育许可（学生或教师）并且<strong>无法访问 Internet</strong> 时才需要激活码。`,
      noteBullet2: `<strong>如果您可以访问 Internet，则不需要激活码。</strong>只需启动产品并按照说明<a target="_blank" href="https://www.autodesk.com/sign-in-activation-chs">登录</a>或<a target="_blank" href="https://www.autodesk.com/access-with-serial-number-chs">输入序列号。</a>`
    },
    signInOptional: {
      title: "登录（可选）",
      message: `登录会更便于操作，但不强制要求登录。`
    },
    overActScreen: {
      actAgainLabel: "选择再次激活的原因",
      pageTitle: "3. 过度激活原因",
      reason1: "新计算机",
      reason2: "计算机被盗",
      reason3: "软件重新安装",
      reason4: "其他",
      responseText: "该序列号先前已激活。",
      selectReason: "选择原因"
    },
    requestFailedScreen: {
      gacExportControlBlock: '“您使用 Autodesk 产品的资格当前正在进行标准出口筛选，通常需要几分钟时间。请稍后重试。有关详细信息，请参见 Autodesk <a target="_blank" href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">出口合规策略</a>。”',
      gacProductKeyAndSerialNotFound: '我们找不到匹配的产品。请确保您输入的序列号正确无误。有关详细信息，请参见<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/download-install/activate/find-serial-number-product-key">查找序列号和产品密钥</a>',
      gacAssetNotFound: '请确保您输入的序列号正确无误。如果这是最近订购的产品，则需要更多的处理时间。请参见<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/download-install/download/subscription-downloads#missing">看不到您的产品？</a>以了解详细信息。',
      gacContactNotFound: "未找到电子邮件。确保输入此序列号的正确电子邮件地址。",
      gacGetAssetActivationCode: "发生错误。单击再次提交。如果尝试几次后该方法不起作用，请与支持人员联系。",
      gacFlexShortRequestCodeInvalid: "这不是有效的请求代码。请确保您输入的代码正确无误。"
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "单击“开始”以获取居家使用许可序列号。",
      intro: "执行这些快速步骤以获取居家使用许可。",
      modalTitle: "申请居家使用许可",
      noteBullet1: '居家使用许可适用于订购了多（人）用户固定期限使用许可和维护服务合约 (maintenance plan) 网络许可的<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-chs">符合条件的产品</a>。',
      noteBullet2: "单（人）用户固定期限使用许可自动包括居家使用许可。您可以使用同一序列号在家用计算机上安装并激活软件。"
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: '上面仅列出符合条件的版本。<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-chs">查看资格要求</a>',
      crossGradeHulaMessage: `我们无法在此处处理您的请求。要针对选定版本获取居家使用许可，请<a id="go-to-create-case" href="javascript:void(0);">创建案例。</a>我们会在两个工作日内回复您。`
    },
    errors: {
      tokenFlexSerialNumber: `您已输入 TokenFlex 序列号。要申请居家使用许可，请向您的 Autodesk 卓越专家发送电子邮件：<strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-chs">查看资格要求</a>',
      hulaIneligible: `无法完成您的申请，因为您的产品不符合居家使用许可的条件。`,
      exportControlBlockOREmbergoList: `您使用 Autodesk 产品的资格当前正在进行标准出口筛选，通常需要几分钟时间。有关详细信息，请参见 Autodesk <a href="https://www.autodesk.com/company/legal-notices-trademarks/compliance"> 出口合规策略 </a>。`
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "单击“开始”以访问先前版本的软件。",
      intro: "执行这些快速步骤以获取先前版本的软件。",
      modalTitle: "申请先前版本",
      noteBullet1: '如果您有固定期限的使用许可，请登录您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>，然后下载所需的先前版本。',
      noteBullet2: '如果您有处于维护服务合约 (maintenance plan) 有效期的单机许可，请使用此方法申请先前版本的<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-chs">符合条件的</a>产品。'
    },
    processInfoScreen: {
      noPvAvailable: '您申请的产品的先前版本不可用。有关详细信息，请参见<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-chs">先前版本策略</a>。',
      pvEduUserMsg: '您有教育许可。请访问 <a target="_blank" href="https://www.autodesk.com/education/free-software/all">Education Community</a>，在此您最多可以下载三个先前版本。',
      pvEligibleVersionMsg: '上面仅列出符合条件的版本。<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">查看资格要求</a>',
      pvMultiUserSubsMsg: `您拥有多（人）用户固定期限使用许可。先前版本序列号显示在您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>中。`,
      pvNetworkMaintenanceUserMsg: `您拥有网络许可。先前版本序列号显示在您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>中。`,
      pvPerpetualUserMsg: 'T此产品的永久使用许可不包括对先前版本的访问权限。<br/><br/>固定期限的使用许可包括对先前版本的访问权限。<a target="_blank" href="https://www.autodesk.com.cn/subscription">了解有关固定期限的使用许可权益的更多信息。</a>',
      pvSingleUserSubsMsg: '您有单（人）用户固定期限使用许可。要最多访问三个先前版本，只需在您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>中指定所需产品。（查找“获取序列号”链接。）',
      serialNumberCurrentLabel: "当前序列号",
      versionRequestingLabel: "您申请的版本"
    },
    errors: {
      tokenFlexSerialNumber: `您已输入 TokenFlex 序列号。要申请先前版本使用许可，请向您的 Autodesk 卓越专家发送电子邮件：<strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-chs">查看资格要求</a>',
      pvInactiveSubscription: '无法完成您的申请，因为在您的<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">帐户</a>中，此产品的固定期限的使用许可不再有效。',
      pvIneligible: "无法完成您的申请，因为您的产品不符合先前版本许可的条件。"
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "单击“快速开始”以更改您的合约经理。",
      modalTitle: "更改合约经理",
      noteBullet1: "针对未设置为自动续展的维护服务合约 (maintenance plan) 和固定期限的使用许可，可更改合约经理。",
      noteBullet2: "对于设置为自动续展的固定期限的使用许可，则必须取消此固定期限的使用许可并启动一个新固定期限的使用许可，然后才能更改合约经理。"
    },
    processInfoScreen: {
      cmEmailPlaceholder: "与合约编号关联",
      contractNumDisclaimer: `如果您的合同编号中含有 1，则包含连字符(-)。`,
      contractNumLabel: "合约编号",
      contractNumTooltip: '在<a target="_blank" href="https://manage.autodesk.com">帐户</a>的“计费和订单”区域中，查找合约编号。',
      currentCmEmailLabel: "当前合约经理的电子邮件",
      newCmEmailLabel: "新合约经理的电子邮件",
      newCmNameLabel: "新合约经理的姓名",
      newCmPhoneLabel: "新合约经理的电话号码",
      pageTitle2: "3. 新信息",
      pageTitle: "2. 当前信息",
      phoneNumPlaceholder: "包含区域代码和区号"
    },
    authorizationRequestScreen: {
      option1: "本人确认是合约经理或拥有此固定期限的使用许可的公司已授限本人提出此申请。",
      confirmLabel: "请确认您有权提出此请求",
      pageTitle: "4. 对此申请的授权"
    },
    successScreen: {
      cmWillReceiveEmail: `新的合约经理会收到一封电子邮件，其中包含更多说明。`,
      emailWillBeSent: "您将收到一封确认电子邮件：<email>",
      responseText4: `合同编号 <contract-number> 拥有新的合约经理:`
    },
    errors: {
      contractNumNotFound: "未找到合约编号",
      emailNotAssociatedWithcontractNum: "此电子邮件未与上述合约编号相关联。",
      enterContractNum: "输入您的合约编号"
    },
    requestFailedScreen: {
      autoRenewSubs: "我们的记录显示，您的固定期限的使用许可已设置为自动续展。要更改合约经理，必须取消此固定期限的使用许可并启动一个新固定期限的使用许可。",
      autoRenewSubsTitle: "自动续展固定期限的使用许可",
      inactiveContract: "您的申请无法完成，因为您的合约不再有效。",
      inactiveContractTitle: "无效合约"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "单击“快速开始”以更改您的软件协调员。",
      modalTitle: "更改软件协调员",
      noteBullet1: "您可以使用此方法更改维护服务合约 (maintenance plan) 和固定期限的使用许可的软件协调员（教育产品除外）。"
    },
    processInfoScreen: {
      currentScEmailLabel: "当前软件协调员的电子邮件",
      newScEmailLabel: "新软件协调员的电子邮件",
      newScNameLabel: "新软件协调员的姓名",
      newScPhoneLabel: "新软件协调员的电话号码",
      scEmailPlaceholder: "与序列号关联",
      importantInformation: "Important information"
    },
    authorizationRequestScreen: {
      option1: "本人确认是合约经理、软件协调员或拥有此固定期限的使用许可的公司已授限本人提出此申请。"
    },
    successScreen: {
      responseText4: `序列号 <serial-number> 拥有新的软件协调员:`,
      scWillReceiveEmail: `新的软件协调员会收到一封电子邮件，其中包含更多说明。`
    },
    errors: {
      emailNotAssociatedWithSerialNum: "此电子邮件未与上述序列号相关联。",
      tokenFlexSerialNumber: `您已输入 TokenFlex 序列号。要更改软件协调员，请向 Autodesk 首席专家发送电子邮件：<strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>.`
    },
    requestFailedScreen: {
      serialNumberIneligle: "您的请求无法完成，因为您的序列号不符合软件协调员更改的条件。",
      serialNumberIneligleTitle: "序列号不符合条件"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: "单击“快速入门”以更改贵公司的联系信息。",
      modalTitle: "更改公司名称或地址",
      noteBullet1: "<strong>如果您是合约经理</strong>，则仅可以更改公司名称和地址。",
      noteBullet2: '<strong>此过程将不会转移所有权。</strong> 要将许可转移给新的所有者，您必须<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">完成许可转移请求</a>。'
    },
    processInfoScreen: {
      reviewInfoTitle: "查看您的帐户信息",
      currentInfoTitle: "当前信息",
      current: "当前：",
      pageTitle2: "输入新信息",
      pageTitleValidateAddr: "验证地址",
      pageTitleConfirmChanges: "确认更改",
      changeInfoLabel: "要更改哪些信息？",
      addressOption: "地址",
      nameOption: "公司名称",
      nameAndAddressOption: "公司名称和地址",
      newTaxIdLabel: "是否还具有新的税号或 EIN",
      msgTOLS: '根据以上答案，您必须<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">完成许可转移</a> 以将许可转移给新的所有者。如果您需要更多帮助，<Strong>请联系以下客户支持</Strong>',
      unauthorizedUser: "您无权更改此合约。",
      msgAutoRenew: '无法在线更改与自动续展循环计费相关的公司名称或地址以及一些基于相关服务的软件合约。请按照以下步骤<a target="_blank" href="https://knowledge.autodesk.com/zh-hans/customer-service/account-management/account-profile/change-company-name-and-address">更改公司名称或地址</a>。',
      msgExpiredContract: "此合约已过期。",
      notEligible: "此合约不符合条件。",
      changingInfoFor: "更改以下合约编号的信息：<contract-number>",
      companyName: "公司名称",
      accountCSN: `的帐户 CSN`,
      streetAddress: "街道地址",
      city: "城市",
      state: "州/省",
      postalCode: "邮政编码",
      country: "国家/地区",
      validateAddDisclaimer: "以下高亮显示了最匹配的地址。选择输入的地址可能会增加处理时间。",
      confirmDisclaimer: "提交前，请检查更改的内容中是否存在任何错误。您可以返回先前屏幕进行任何必要编辑。",
      recommendedAddr: "最匹配的地址",
      enteredAddr: "输入的地址",
      changeWillbeAppliedFor: "更改的内容将应用于以下合约编号：<contract-number>",
      new: "新的",
      old: "旧的",
      emailWillBeSent: "您将在以下位置收到一封确认电子邮件：<email>"
    },
    successScreen: {
      emailWillBeSent: "您将在以下位置收到一封确认电子邮件：<email>",
      changeAppliedFor: "合约编号 <contract-number> 已更新为以下内容：",
      nonCleansedAddrMsg: "您很快会收到一封确认电子邮件，其中包含您的案例编号。请留存此电子邮件作为记录.<br><br><strong>我们将在两个工作日内对您的案例做出响应.</strong><br><br>如果您在一小时内未收到确认电子邮件，请检查您的垃圾邮件文件夹，或联系您的网络管理员以获取更多帮助。"
    },
    errors: {
      contractNumNotFound: "未找到合约编号",
      invalidContractNum: "无效的合同编号",
      enterContractNum: "输入您的合约编号"
    }
  }
};